var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c("app-agreement"),
      _vm.showWatermark
        ? _c("Watermark", _vm._b({}, "Watermark", { ..._vm.form }, false))
        : _vm._e(),
      _vm.keepAlive ? _c("keep-alive", [_c("router-view")], 1) : _vm._e(),
      !_vm.keepAlive ? _c("router-view") : _vm._e(),
      _c("ai-helper"),
      _c("callPhone"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }